import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";
import reviewReply from "./modules/reviewReply";
import dashBoard from "./modules/dashBoard";
import socialMedia from "./modules/socialMedia";
import auth from "./modules/auth";
import hotel from "./modules/hotel";
import goal from "./modules/goal";
import restaurant from "./modules/restaurant";
import userTimeFilter from "./modules/userTimeFilter";
import exportStatus from "./modules/exportStatus";
import serviceCategories from "./modules/serviceCategories";
import brandNav from "./modules/brandNav";
import { PENDING_HOTEL_ID_KEY } from "@/utils/pendingHotelSwitch";

Vue.use(Vuex);

const store = new Vuex.Store({
  modules: {
    auth,
    reviewReply,
    dashBoard,
    socialMedia,
    hotel,
    restaurant,
    userTimeFilter,
    goal,
    exportStatus,
    serviceCategories,
    brandNav,
  },
  plugins: [
    createPersistedState({
      key: "vuex",
      storage: window.localStorage,
      paths: [
        "hotel.currentHotelId",
        "hotel.hotelList",
        "hotel.isHotel",
        "hotel.isShowSider",
        "restaurant.selectedRestaurantId",
        "restaurant.restaurantList",
        "auth.brands",
        "auth.selectedBrandName",
        // hotelTime / reviewTime 不持久化（WTK-767）：每次打开 / 刷新都回到 Last 7 days，见 userTimeFilter.js
        "userTimeFilter.RestaurantReviewsTime",
        "userTimeFilter.competitorsTime",
        "userTimeFilter.RestaurantDashboardTime",
        "userTimeFilter.brandTime",
      ],
    }),
  ],
});

// 退出品牌模式切到 Hotel 时（RouterMenu.vue switchModule）存的“待选酒店”——见 pendingHotelSwitch.js
// 的注释。这里是新页面刚整页加载、store 刚创建（BrandOverview2 早已卸载）的时机，可以放心 commit。
const pendingHotelId = window.sessionStorage.getItem(PENDING_HOTEL_ID_KEY);
if (pendingHotelId) {
  store.commit("hotel/SET_CURRENT_HOTEL", pendingHotelId);
  window.sessionStorage.removeItem(PENDING_HOTEL_ID_KEY);
}

export default store;
